<script lang="ts">
	import Text from '../../../Text.svelte';
	import InterestList from '../../InterestList.svelte';
	import { interestListFormatter } from '../../../../utils';
	import { interests as interestList } from '../../../../stores';
	export let row: any;
</script>

<div class="interests">
	{#if !((row.lookalikeId !== '' && row.lookalikeId !== null) || (row.targetId !== '' && row.targetId !== null))}
		{#if JSON.parse(row.interests).length > 0}
			<div>
				<Text type="body1">{Math.floor(row.certainty * 100)}%</Text>
				<InterestList
					operator={row.operator}
					interestList={interestListFormatter(
						JSON.stringify(JSON.parse(row.interests)),
						$interestList
					)}
				/>
			</div>
		{/if}
		{#if JSON.parse(row.defaultInterests).length > 0}
			<div>
				<Text type="body1">{Math.floor(row.certaintyDefaultInterests * 100)}%</Text>
				<InterestList
					operator={row.interestOperator}
					interestList={interestListFormatter(
						JSON.stringify(JSON.parse(row.defaultInterests)),
						$interestList
					)}
				/>
			</div>
		{/if}
	{/if}
</div>

<style>
	.interests {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
	}
</style>
